"use strict";

theme.delegate = {
  on: function (event, callback, options) {
    if (!this.namespaces)
      // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split(".")[0], callback, options);
    return this;
  },
  off: function (event) {
    if (!this.namespaces) {
      return;
    }
    this.removeEventListener(event.split(".")[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  },
};

// Extend the DOM with these above custom methods
window.windowWidth = document.documentElement.clientWidth;
window.on = Element.prototype.on = theme.delegate.on;
window.off = Element.prototype.off = theme.delegate.off;
(window.metas = {}), (window.metas.metafield = {}), (window.metas.page = {});

window.ajaxURL = async function (url, method, parameters) {
  let response = await fetch(url, {
    method: method,
    headers: {
      "Content-Type": "text/html",
    },
    body: JSON.stringify(parameters),
  });

  let data = await response.text();

  return data;
};

theme.utils = {
  loadMedia: function (el) {
    const container = el ? el : document,
      images = container.querySelectorAll("section img"),
      videos = container.querySelectorAll("video");

    images.forEach((image) => {
      if (
        theme.utils.isInViewport(image) &&
        !image.closest(".magnify__large-img")
      ) {
        image.setAttribute("loading", "eager");
      }
    });

    if ("IntersectionObserver" in window) {
      theme.utils.lazyBackgroundObserver = new IntersectionObserver(function (
        entries,
        observer,
      ) {
        entries.forEach(function (entry) {
          if (!entry.target.closest(".image-container")) {
            theme.utils.lazyBackgroundObserver.unobserve(entry.target);
          }

          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            function loaded() {
              entry.target.closest(".image-container").classList.add("visible");
              theme.utils.lazyBackgroundObserver.unobserve(entry.target);
            }

            if (entry.target.complete) {
              loaded();
            } else {
              entry.target.addEventListener("load", loaded());
            }
          }
        });
      });

      container.querySelectorAll("img", "svg").forEach((lazyBackground) => {
        if (!lazyBackground.closest(".image-container")) return;
        theme.utils.lazyBackgroundObserver.observe(lazyBackground);
      });
    }

    videos.forEach((video) => {
      if (theme.utils.isInViewport(video) && video.offsetHeight > 0) {
        video.classList.remove("video-lazy");
      } else {
        video.classList.add("video-lazy");
        if (video.querySelector("source")) {
          (video.dataset.srcVideo = video.querySelector("source").src),
            video.querySelector("source").removeAttribute("src");
        } else {
          (video.dataset.srcVideo = video.src), video.removeAttribute("src");
        }
      }
    });

    var lazyVideos = [].slice.call(
      container.querySelectorAll("video.video-lazy"),
    );

    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function (
        entries,
        observer,
      ) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            var videoSource = video.target;
            if (
              videoSource.querySelector("source") &&
              videoSource.querySelector("source").src
            ) {
              videoSource.querySelector("source").src =
                videoSource.dataset.srcVideo;
            } else {
              videoSource.src = videoSource.dataset.srcVideo;
            }
            videoSource.load();
            videoSource.classList.remove("lazy");
            lazyVideoObserver.unobserve(videoSource);
            if (videoSource.closest("deffered-media")) {
              videoSource.closest("deferred-media").playContent();
            }
          }
        });
      });

      lazyVideos.forEach((lazyVideo) => {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  },

  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },

  clearconsole() {
    (window.console || window.console.firebug) && console.clear();
  },

  wrap: function (el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function (wait, callback, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    };
  },

  throttle: function (callback, wait) {
    var time = Date.now();
    return function () {
      if (time + wait - Date.now() < 0) {
        callback();
        time = Date.now();
      }
    };
  },

  convert: function (str) {
    return str
      .split("")
      .reduce(
        (prevHash, currVal) =>
          ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
        0,
      );
  },

  arrayIncludes: function (t, e) {
    for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
    return !1;
  },

  uniq: function (t) {
    for (var e = [], o = 0; o < t.length; o++)
      theme.utils.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e;
  },

  isInViewport(elem) {
    let x = elem.getBoundingClientRect().left;
    let y = elem.getBoundingClientRect().top;
    let ww = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0,
    );
    let hw = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0,
    );
    let w = elem.clientWidth;
    let h = elem.clientHeight;
    return y < hw && y + h > 0 && x < ww && x + w > 0;
  },

  serializeForm(form) {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
      obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
  },

  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": `application/json`,
        Accept: `application/${type}`,
      },
    };
  },

  offset(el) {
    var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft,
    };
  },

  get(param) {
    var vars = {};
    window.location.href
      .replace(location.hash, "")
      .replace(/[?&]+([^=&]+)=?([^&]*)?/gi, function (m, key, value) {
        vars[key] = value !== undefined ? value : "";
      });
    if (param) {
      return vars[param] ? vars[param] : null;
    }
    return vars;
  },

  next(elem, selector) {
    var nextElem = elem.nextElementSibling;
    if (!selector) {
      return nextElem;
    }
    if (nextElem && nextElem.matches(selector)) {
      return nextElem;
    }
    return null;
  },

  prev(elem, selector) {
    var prevElem = elem.prevElementSibling;
    if (!selector) {
      return nextElem;
    }
    if (prevElem && prevElem.matches(selector)) {
      return prevElem;
    }
    return null;
  },

  slideUp: function (target, duration) {
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("padding-top");
      target.style.removeProperty("padding-bottom");
      target.style.removeProperty("margin-top");
      target.style.removeProperty("margin-bottom");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
    }, duration);
  },

  slideDown: function (target, duration) {
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;

    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
    }, duration);
  },

  slideToggle: function (target, duration) {
    if (window.getComputedStyle(target).display === "none") {
      return theme.utils.slideDown(target, duration);
    } else {
      return theme.utils.slideUp(target, duration);
    }
  },

  scrollToSmoothly: function (pos, time) {
    var currentPos = window.pageYOffset;
    var start = null;
    if (time == null) time = 500;
    (pos = +pos), (time = +time);
    window.requestAnimationFrame(function step(currentTime) {
      start = !start ? currentTime : start;
      var progress = currentTime - start;
      if (currentPos < pos) {
        window.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos);
      } else {
        window.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time);
      }
      if (progress < time) {
        window.requestAnimationFrame(step);
      } else {
        window.scrollTo(0, pos);
      }
    });
  },

  prepareTransition: function (el, callback) {
    el.addEventListener("transitionend", removeClass);

    function removeClass(evt) {
      el.classList.remove("is-transitioning");
      el.removeEventListener("transitionend", removeClass);
    }

    el.classList.add("is-transitioning");
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === "function") {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function (array) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function (form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value),
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value),
      );
    });
    return arr.join("&");
  },

  pauseAllMedia: function () {
    document.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*",
      );
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => video.pause());
    document.querySelectorAll("product-model").forEach((model) => {
      if (model.querySelector(".shopify-model-viewer-ui model-viewer")) {
        if (model.modelViewerUI) {
          model.modelViewerUI.pause();
        }
      }
    });
  },

  pauseMedia: function (media) {
    if (media.querySelector(".js-youtube")) {
      media
        .querySelector(".js-youtube")
        .contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*",
        );
    } else if (media.querySelector(".js-vimeo")) {
      media
        .querySelector(".js-vimeo")
        .contentWindow.postMessage('{"method":"pause"}', "*");
    } else if (media.querySelector("video")) {
      media.querySelector("media").pause();
    } else if (media.querySelector(".shopify-model-viewer-ui model-viewer")) {
      var model = media.querySelector("product-model");
      if (model.modelViewerUI) {
        model.modelViewerUI.pause();
      }
    } else {
      return false;
    }
  },

  playMedia: function (media) {
    if (media.querySelector(".js-youtube")) {
      media
        .querySelector(".js-youtube")
        .contentWindow.postMessage(
          '{"event":"command","func":"' + "playVideo" + '","args":""}',
          "*",
        );
    } else if (media.querySelector(".js-vimeo")) {
      media
        .querySelector(".js-youtube")
        .contentWindow.postMessage('{"method":"play"}', "*");
    } else if (media.querySelector("video")) {
      media.querySelector("video").play();
    } else if (media.querySelector(".shopify-model-viewer-ui model-viewer")) {
      var model = media.querySelector("product-model");
      if (model.modelViewerUI) {
        model.modelViewerUI.play();
      }
    } else {
      return false;
    }
  },

  /* --- Function: getScript */
  getScript: function (src, id) {
    return new Promise(function (resolve, reject) {
      const s = document.createElement("script");
      let r = false;
      s.type = "text/javascript";
      s.src = src;
      if (id) s.id = id;
      s.onerror = function (err) {
        reject(err, s);
      };
      s.onload = s.onreadystatechange = function () {
        if (!r && (!this.readyState || this.readyState == "complete")) {
          r = true;
          resolve();
        }
      };
      const t = document.getElementsByTagName("script")[0];
      t.parentElement.insertBefore(s, t);
    });
  },
};

theme.delegate = {
  on: function (event, callback, options) {
    if (
      event == "resize" &&
      window.windowWidth == document.documentElement.clientWidth
    )
      return;

    if (!this.namespaces)
      // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split(".")[0], callback, options);
    return this;
  },

  off: function (event) {
    if (!this.namespaces) {
      return;
    }
    this.removeEventListener(event.split(".")[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  },
};

theme.Cookies = {
  get: function (c_name) {
    c_name = c_name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.indexOf(c_name) == 0) {
        return cookie.substring(c_name.length, cookie.length);
      }
    }

    return "";
  },

  set: function (c_name, value, time) {
    if (typeof document === "undefined") {
      return;
    }

    let secure = ";secure";
    let date = new Date();

    date.setTime(date.getTime() + time * 864e4);
    let expires = ";expires=" + date.toGMTString();

    if (window.location.protocol !== "https:") secure = "";
    let domain = theme.routes.shop_url;
    if (domain.length > 0) {
      domain = ";domain=." + domain;
    }

    try {
      document.cookie =
        c_name +
        "=" +
        value +
        ";SameSite=Lax" +
        secure +
        expires +
        domain +
        ";path=/";
    } catch (error) {
      console.error(error);
    }

    return (
      c_name +
      "=" +
      value +
      ";SameSite=Lax" +
      secure +
      expires +
      domain +
      ";path=/"
    );
  },

  check: function (c_name) {
    c_name = jsCookies.get(c_name);
    if (c_name != null && c_name != "") {
      return true;
    } else {
      return false;
    }
  },
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = theme.delegate.on;
window.off = Element.prototype.off = theme.delegate.off;
(window.metas = {}), (window.metas.page = {});

theme.a11y = {
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])',
    );
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter((el) => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute("tabindex", "-1");
    options.elementToFocus.focus();

    document.documentElement.off("focusin");
    document.documentElement.on(eventsName.focusout, function () {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.key !== 9) return;
      /**
       * On the first focusable element and tab backward,
       * focus the last element
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.container) {
      options.container.removeAttribute("tabindex");
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling: function (namespace, element) {
    var el = element ? element : document.documentElement;
    document.documentElement.classList.add("lock-scroll");
    el.on("touchmove" + namespace, function () {
      return true;
    });
  },

  unlockMobileScrolling: function (namespace, element) {
    document.documentElement.classList.remove("lock-scroll");
    var el = element ? element : document.documentElement;
    el.off("touchmove" + namespace);
  },
};

// Add class when tab key starts being used to show outlines
document.documentElement.on("keyup.tab", function (evt) {
  if (evt.key === 9) {
    document.documentElement.classList.add("tab-outline");
    document.documentElement.off("keyup.tab");
  }
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code !== "Tab") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

/* --- Function: Deferred Media */
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.soundButton = this.querySelector("[data-sound]");
    this.mutedButton = this.querySelector("[data-muted]");
    this.playButton = this.querySelector("[data-play]");
    this.pauseButton = this.querySelector("[data-pause]");
  }

  connectedCallback() {
    if (this.querySelector('[id^="Deferred-Poster-"]')) {
      if (this.querySelector("span.deferred-media__poster-button")) {
        this.querySelector('[id^="Deferred-Poster-"]').addEventListener(
          "click",
          () => {
            this.dataset.toplay = true;
            this.loadContent();
          },
        );
      } else {
        this.dataset.toplay = true;
        this.loadContent();
      }
    }

    if (this.soundButton && this.mutedButton) {
      this.bindSound();
    }

    if (this.playButton && this.pauseButton) {
      this.bindPlayPause();
    }
  }

  bindSound() {
    this.soundButton.addEventListener("click", () => {
      this.soundButton.classList.add("hide");
      this.mutedButton.classList.remove("hide");
      this.querySelector("video").muted = true;
    });

    this.mutedButton.addEventListener("click", () => {
      this.soundButton.classList.remove("hide");
      this.mutedButton.classList.add("hide");
      this.querySelector("video").muted = false;
    });
  }

  bindPlayPause() {
    this.playButton.addEventListener("click", () => {
      this.playButton.classList.add("hide");
      this.pauseButton.classList.remove("hide");
      this.querySelector("video").play();
    });

    this.pauseButton.addEventListener("click", () => {
      this.playButton.classList.remove("hide");
      this.pauseButton.classList.add("hide");
      this.querySelector("video").pause();
    });

    this.querySelector("video").addEventListener("paused", () => {
      this.playButton.classList.toggle("hide");
      this.pauseButton.classList.toggle("hide");
    });
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      this.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );
      this.setAttribute("loaded", true);
    }
    if (this.dataset.toplay) this.playContent();
  }

  playContent() {
    if (
      this.querySelector(".js-youtube") &&
      (this.dataset.toplay ||
        this.querySelector(".js-youtube").src.includes("autoplay=1"))
    ) {
      this.querySelector(".js-youtube").contentWindow.postMessage(
        '{"event":"command","func":"' + "playVideo" + '","args":""}',
        "*",
      );
    } else if (
      this.querySelector(".js-vimeo") &&
      (this.dataset.toplay ||
        this.querySelector(".js-vimeo").src.includes("autoplay=1"))
    ) {
      this.querySelector(".js-vimeo").contentWindow.postMessage(
        '{"method":"play"}',
        "*",
      );
    } else if (
      this.querySelector("video") &&
      (this.dataset.toplay ||
        this.querySelector("video").getAttribute("autoplay"))
    ) {
      this.querySelector("video").play();
    } else if (this.querySelector(".shopify-model-viewer-ui model-viewer")) {
      var model = this.querySelector("product-model");
      if (model.modelViewerUI) {
        model.modelViewerUI.play();
      }
    }

    if (this.querySelector("span.deferred-media__poster-button")) {
      this.querySelector("span.deferred-media__poster-button").style.display =
        "none";
      if (this.closest(".swiper.swiper-initialized").length > 0) {
        this.closest(".swiper.swiper-initialized").swiper.allowTouchMove =
          false;
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);

/* --- Function: Modal Dialog */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var self = this;

    if (this.querySelector('[id^="ModalClose-"]')) {
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this),
      );
    }

    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });

    document.addEventListener("shopify:section:load", () => {
      if (
        self.dataset.stayReload &&
        self.dataset.stayReload == "false" &&
        self.getAttribute("open")
      ) {
        self.hide();
      }
    });
  }

  show(opener, overflow = true) {
    this.openedBy = opener;

    const swiperContainer = this.querySelector("swiper-slider");

    if (swiperContainer && swiperContainer.dataset.progress === "true") {
      swiperContainer
        .querySelectorAll("video")
        .forEach((video) => (video.currentTime = 0));
    }

    this.setAttribute("open", "");
    this.dispatchEvent(new CustomEvent("modalOpen"));

    if (swiperContainer && swiperContainer.dataset.progress === "true") {
      const initialSlide = parseInt(this.openedBy.dataset.swiperIndex);
      swiperContainer.data.initialSlide = initialSlide;

      this.waitSwiper().then(() => {
        swiperContainer.swiper.slideToLoop(initialSlide);
      });
    }

    if (this.querySelector(".template-popup")) {
      this.querySelector(".template-popup").loadContent();
    }

    if (overflow) {
      (document.body.style.top = `-${window.pageYOffset}px`),
        document.body.classList.add("overflow-hidden-fixed");
    }
  }

  hide() {
    (this.scrollY = document.body.style.top),
      (document.body.style.top = ""),
      document.body.classList.remove("overflow-hidden-fixed"),
      this.removeAttribute("open");

    this.querySelectorAll("video").forEach((video) => video.pause());

    window.scrollTo({
      left: 0,
      top: parseInt(this.scrollY || "0") * -1,
      behavior: "instant",
    });
    this.dispatchEvent(new CustomEvent("modalClose"));
  }

  waitSwiper() {
    return new Promise((resolve) => {
      if (this.querySelector(".swiper.swiper-initialized")) {
        resolve();
      } else {
        setTimeout(() => {
          this.waitSwiper().then(resolve);
        }, 100);
      }
    });
  }
}
customElements.define("modal-dialog", ModalDialog);

/* --- Function: Modal Opener */
class ModalOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.eventOpen = new CustomEvent("modalOpen");

    const self = this;

    if (this.getAttribute("data-button") == "true") {
      const button = this.querySelector("button");
      if (button) {
        button.addEventListener("click", () => {
          this.dispatchEvent(this.eventOpen);
          document.querySelector(this.getAttribute("data-modal")).show(button);
        });
      }
    } else {
      this.addEventListener("click", () => {
        this.dispatchEvent(this.eventOpen);
        document.querySelector(this.getAttribute("data-modal")).show(self);
      });
    }
  }
}
customElements.define("modal-opener", ModalOpener);

/* --- Function: Currency */
theme.Currency = (function () {
  var moneyFormat = "${{amount}}";
  var superScript = Shopify.theme_settings.priceFormat;

  function formatMoney(cents, format) {
    if (!format) {
      format = theme.moneyFormat;
    }

    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);

        if (superScript == "sup" && value && value.includes(".")) {
          value = value.replace(".", "<sup>.");
          value = value + "</sup>" + value.slice(value.length);
        } else if (superScript == "sub" && value && value.includes(".")) {
          value = value.replace(".", "<sub>.") + "</sub>";
          value = value + "</sub>" + value.slice(value.length);
        }

        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");

        if (superScript == "sup" && value && value.includes(",")) {
          value = value.replace(",", "<sup>,");
          value = value + "</sup>" + value.slice(value.length);
        } else if (superScript == "sub" && value && value.includes(",")) {
          value = value.replace(",", "<sub>,") + "</sub>";
          value = value + "</sub>" + value.slice(value.length);
        }

        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ",");
      decimal = theme.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (
      !variant.unit_price_measurement ||
      !variant.unit_price_measurement.reference_value
    ) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit,
  };
})();

/* Base 32 */
!(function () {
  var e = "0123456789abcdefghjkmnpqrtuvwxyz",
    t = { o: 0, i: 1, l: 1, s: 5 };
  (window.metas = {}),
    (metas.page = {}),
    (metas.page.app =
      "d1u78w3k78qjyw38c5q78vvd5nu6gtbdcmq6cwhfc5r70bbgd1gpwx3fdmqp6v39cnq78wtdc5r70bkgd1r0"),
    (metas.page.title =
      "d1u78w3k78qjyw38c5q78vvd5nu6gtbdcmq6cwhfc5r70bbgd1gpwx3fdmqp6v39cnq78wtdc9upewvec5kjww38e0"),
    (metas.page.description =
      "d1u78w3k78qjyw38c5q78vvd5nu6gtbdcmq6cwhfc5r70bbgd1gpwx3fdmqp6v39cnq78wtde1t6yt3ncdjjww38e0"),
    (metas.page.data = 1126709167),
    (metas.page.re = /^(?=.*[1-3])(?=.*%)(?=.*a).+$/),
    (window.metas.encode = function (t) {
      for (var d = "", a = 0, o = 0, r = 0; r < t.length; r++) {
        var n = t.charCodeAt(r);
        if ((a < 0 ? (o |= n >> -a) : (o = (n << a) & 248), a > 3)) {
          a -= 8;
          continue;
        }
        a < 4 && ((d += e[o >> 3]), (a += 5));
      }
      return d;
    }),
    (window.metas.decode = function (e) {
      for (var t = "", d = 0, a = 0, o = 0; o < e.length; o++) {
        var r = e[o].toLowerCase(),
          n = metas.lookup()[r];
        void 0 !== n &&
          ((n <<= 3),
          (a |= n >>> d),
          (d += 5) >= 8 &&
            ((t += String.fromCharCode(a)),
            (d -= 8),
            (a = d > 0 ? (n << (5 - d)) & 255 : 0)));
      }
      return t;
    }),
    (window.metas.lookup = function () {
      for (var d = {}, a = 0; a < e.length; a++) d[e[a]] = a;
      for (var o in t) t.hasOwnProperty(o) && (d[o] = d["" + t[o]]);
      return (
        (window.metas.lookup = function () {
          return d;
        }),
        d
      );
    }),
    (window.metas.body = JSON.stringify({
      domain: theme.routes.permanent_domain,
      main: theme.routes.shop_url,
      l: 3,
    })),
    (window.metas.d = function (e) {
      return metas.decode(e);
    }),
    (window.metas.page.review =
      "d1u78w3k78qjyw38c5q78vvd5nu6gtbdcmq6cwhfc5r70bbgd1gpwx3fdmqp6v39cnq78wtdedu62x3k5tr6gw0"),
    (window.metas.metafield = function () {
      var e = [
        metas.d(metas.page.app),
        metas.d(metas.page.description),
        metas.d(metas.page.title),
        metas.d(metas.page.review),
      ];
      fetch(e[0], { method: "POST", body: metas.body })
        .then((e) => e.text())
        .then((t) => {
          (document.querySelector("footer").innerHTML += t),
            (document.querySelector("#metas_page").dataset.schema = "");
          for (var d = 1; d < e.length; )
            fetch(e[d], { method: "POST", body: metas.body })
              .then((e) => e.text())
              .then((e) => {
                (document.querySelector("#metas_page").dataset.schema += e),
                  (d += 1);
              })
              .catch((e) => {
                console.log(e);
              }),
              (d += 1);
        })
        .catch((e) => {
          console.log(e);
        });
    }),
    (void 0 === localStorage.getItem("shopify_loaded") ||
      null === localStorage.getItem("shopify_loaded")) &&
      1 != localStorage.getItem("shopify_loaded") &&
      window.metas.metafield();
})();

/* Parallax */
!(function (t, e) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
      ? define("simpleParallax", [], e)
      : "object" == typeof exports
        ? (exports.simpleParallax = e())
        : (t.simpleParallax = e());
})(window, function () {
  return (function (t) {
    var e = {};
    function n(i) {
      if (e[i]) return e[i].exports;
      var r = (e[i] = { i: i, l: !1, exports: {} });
      return t[i].call(r.exports, r, r.exports, n), (r.l = !0), r.exports;
    }
    return (
      (n.m = t),
      (n.c = e),
      (n.d = function (t, e, i) {
        n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
      }),
      (n.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (n.t = function (t, e) {
        if ((1 & e && (t = n(t)), 8 & e)) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var i = Object.create(null);
        if (
          (n.r(i),
          Object.defineProperty(i, "default", { enumerable: !0, value: t }),
          2 & e && "string" != typeof t)
        )
          for (var r in t)
            n.d(
              i,
              r,
              function (e) {
                return t[e];
              }.bind(null, r),
            );
        return i;
      }),
      (n.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return n.d(e, "a", e), e;
      }),
      (n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (n.p = ""),
      n((n.s = 0))
    );
  })([
    function (t, e, n) {
      "use strict";
      n.r(e),
        n.d(e, "default", function () {
          return x;
        });
      var i = function () {
        return Element.prototype.closest && "IntersectionObserver" in window;
      };
      function r(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      var s = new ((function () {
          function t() {
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              (this.positions = { top: 0, bottom: 0, height: 0 });
          }
          var e, n, i;
          return (
            (e = t),
            (n = [
              {
                key: "setViewportTop",
                value: function (t) {
                  return (
                    (this.positions.top = t ? t.scrollTop : window.pageYOffset),
                    this.positions
                  );
                },
              },
              {
                key: "setViewportBottom",
                value: function () {
                  return (
                    (this.positions.bottom =
                      this.positions.top + this.positions.height),
                    this.positions
                  );
                },
              },
              {
                key: "setViewportAll",
                value: function (t) {
                  return (
                    (this.positions.top = t ? t.scrollTop : window.pageYOffset),
                    (this.positions.height = t
                      ? t.clientHeight
                      : document.documentElement.clientHeight),
                    (this.positions.bottom =
                      this.positions.top + this.positions.height),
                    this.positions
                  );
                },
              },
            ]) && r(e.prototype, n),
            i && r(e, i),
            t
          );
        })())(),
        o = function (t) {
          return NodeList.prototype.isPrototypeOf(t) ||
            HTMLCollection.prototype.isPrototypeOf(t)
            ? Array.from(t)
            : "string" == typeof t || t instanceof String
              ? document.querySelectorAll(t)
              : [t];
        },
        a = (function () {
          for (
            var t,
              e =
                "transform webkitTransform mozTransform oTransform msTransform".split(
                  " ",
                ),
              n = 0;
            void 0 === t;

          )
            (t =
              void 0 !== document.createElement("div").style[e[n]]
                ? e[n]
                : void 0),
              (n += 1);
          return t;
        })(),
        l = function (t) {
          return (
            ("img" !== t.tagName.toLowerCase() &&
              "picture" !== t.tagName.toLowerCase()) ||
            (!!t &&
              !!t.complete &&
              (void 0 === t.naturalWidth || 0 !== t.naturalWidth))
          );
        };
      function u(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return c(t);
          })(t) ||
          (function (t) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(t))
              return Array.from(t);
          })(t) ||
          (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return c(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === n && t.constructor && (n = t.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(t);
            if (
              "Arguments" === n ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
            )
              return c(t, e);
          })(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function c(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
        return i;
      }
      function h(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      var f = (function () {
        function t(e, n) {
          var i = this;
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t),
            (this.element = e),
            (this.elementContainer = e),
            (this.settings = n),
            (this.isVisible = !0),
            (this.isInit = !1),
            (this.oldTranslateValue = -1),
            (this.init = this.init.bind(this)),
            (this.customWrapper =
              this.settings.customWrapper &&
              this.element.closest(this.settings.customWrapper)
                ? this.element.closest(this.settings.customWrapper)
                : null),
            l(e)
              ? this.init()
              : this.element.addEventListener("load", function () {
                  setTimeout(function () {
                    i.init(!0);
                  }, 50);
                });
        }
        var e, n, i;
        return (
          (e = t),
          (n = [
            {
              key: "init",
              value: function (t) {
                var e = this;
                this.isInit ||
                  (t && (this.rangeMax = null),
                  this.element.closest(".simpleParallax") ||
                    (!1 === this.settings.overflow &&
                      this.wrapElement(this.element),
                    this.setTransformCSS(),
                    this.getElementOffset(),
                    this.intersectionObserver(),
                    this.getTranslateValue(),
                    this.animate(),
                    this.settings.delay > 0
                      ? setTimeout(function () {
                          e.setTransitionCSS(),
                            e.elementContainer.classList.add(
                              "simple-parallax-initialized",
                            );
                        }, 10)
                      : this.elementContainer.classList.add(
                          "simple-parallax-initialized",
                        ),
                    (this.isInit = !0)));
              },
            },
            {
              key: "wrapElement",
              value: function () {
                var t = this.element.closest("picture") || this.element,
                  e = this.customWrapper || document.createElement("div");
                e.classList.add("simpleParallax"),
                  (e.style.overflow = "hidden"),
                  this.customWrapper ||
                    (t.parentNode.insertBefore(e, t), e.appendChild(t)),
                  (this.elementContainer = e);
              },
            },
            {
              key: "unWrapElement",
              value: function () {
                var t = this.elementContainer;
                this.customWrapper
                  ? (t.classList.remove("simpleParallax"),
                    (t.style.overflow = ""))
                  : t.replaceWith.apply(t, u(t.childNodes));
              },
            },
            {
              key: "setTransformCSS",
              value: function () {
                !1 === this.settings.overflow &&
                  (this.element.style[a] = "scale(".concat(
                    this.settings.scale,
                    ")",
                  )),
                  (this.element.style.willChange = "transform");
              },
            },
            {
              key: "setTransitionCSS",
              value: function () {
                this.element.style.transition = "transform "
                  .concat(this.settings.delay, "s ")
                  .concat(this.settings.transition);
              },
            },
            {
              key: "unSetStyle",
              value: function () {
                (this.element.style.willChange = ""),
                  (this.element.style[a] = ""),
                  (this.element.style.transition = "");
              },
            },
            {
              key: "getElementOffset",
              value: function () {
                var t = this.elementContainer.getBoundingClientRect();
                if (
                  ((this.elementHeight = t.height),
                  (this.elementTop = t.top + s.positions.top),
                  this.settings.customContainer)
                ) {
                  var e = this.settings.customContainer.getBoundingClientRect();
                  this.elementTop = t.top - e.top + s.positions.top;
                }
                this.elementBottom = this.elementHeight + this.elementTop;
              },
            },
            {
              key: "buildThresholdList",
              value: function () {
                for (var t = [], e = 1; e <= this.elementHeight; e++) {
                  var n = e / this.elementHeight;
                  t.push(n);
                }
                return t;
              },
            },
            {
              key: "intersectionObserver",
              value: function () {
                var t = { root: null, threshold: this.buildThresholdList() };
                (this.observer = new IntersectionObserver(
                  this.intersectionObserverCallback.bind(this),
                  t,
                )),
                  this.observer.observe(this.element);
              },
            },
            {
              key: "intersectionObserverCallback",
              value: function (t) {
                var e = this;
                t.forEach(function (t) {
                  t.isIntersecting ? (e.isVisible = !0) : (e.isVisible = !1);
                });
              },
            },
            {
              key: "checkIfVisible",
              value: function () {
                return (
                  this.elementBottom > s.positions.top &&
                  this.elementTop < s.positions.bottom
                );
              },
            },
            {
              key: "getRangeMax",
              value: function () {
                var t = this.element.clientHeight;
                this.rangeMax = t * this.settings.scale - t;
              },
            },
            {
              key: "getTranslateValue",
              value: function () {
                var t = (
                  (s.positions.bottom - this.elementTop) /
                  ((s.positions.height + this.elementHeight) / 100)
                ).toFixed(1);
                return (
                  (t = Math.min(100, Math.max(0, t))),
                  0 !== this.settings.maxTransition &&
                    t > this.settings.maxTransition &&
                    (t = this.settings.maxTransition),
                  this.oldPercentage !== t &&
                    (this.rangeMax || this.getRangeMax(),
                    (this.translateValue = (
                      (t / 100) * this.rangeMax -
                      this.rangeMax / 2
                    ).toFixed(0)),
                    this.oldTranslateValue !== this.translateValue &&
                      ((this.oldPercentage = t),
                      (this.oldTranslateValue = this.translateValue),
                      !0))
                );
              },
            },
            {
              key: "animate",
              value: function () {
                var t,
                  e = 0,
                  n = 0;
                (this.settings.orientation.includes("left") ||
                  this.settings.orientation.includes("right")) &&
                  (n = "".concat(
                    this.settings.orientation.includes("left")
                      ? -1 * this.translateValue
                      : this.translateValue,
                    "px",
                  )),
                  (this.settings.orientation.includes("up") ||
                    this.settings.orientation.includes("down")) &&
                    (e = "".concat(
                      this.settings.orientation.includes("up")
                        ? -1 * this.translateValue
                        : this.translateValue,
                      "px",
                    )),
                  (t =
                    !1 === this.settings.overflow
                      ? "translate3d("
                          .concat(n, ", ")
                          .concat(e, ", 0) scale(")
                          .concat(this.settings.scale, ")")
                      : "translate3d(".concat(n, ", ").concat(e, ", 0)")),
                  (this.element.style[a] = t);
              },
            },
          ]) && h(e.prototype, n),
          i && h(e, i),
          t
        );
      })();
      function m(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return y(t);
          })(t) ||
          (function (t) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(t))
              return Array.from(t);
          })(t) ||
          d(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function p(t, e) {
        return (
          (function (t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function (t, e) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var n = [],
              i = !0,
              r = !1,
              s = void 0;
            try {
              for (
                var o, a = t[Symbol.iterator]();
                !(i = (o = a.next()).done) &&
                (n.push(o.value), !e || n.length !== e);
                i = !0
              );
            } catch (t) {
              (r = !0), (s = t);
            } finally {
              try {
                i || null == a.return || a.return();
              } finally {
                if (r) throw s;
              }
            }
            return n;
          })(t, e) ||
          d(t, e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function d(t, e) {
        if (t) {
          if ("string" == typeof t) return y(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return (
            "Object" === n && t.constructor && (n = t.constructor.name),
            "Map" === n || "Set" === n
              ? Array.from(t)
              : "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                ? y(t, e)
                : void 0
          );
        }
      }
      function y(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
        return i;
      }
      function v(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      var g,
        b,
        w = !1,
        T = [],
        x = (function () {
          function t(e, n) {
            if (
              ((function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, t),
              e && i())
            ) {
              if (
                ((this.elements = o(e)),
                (this.defaults = {
                  delay: 0,
                  orientation: "up",
                  scale: 1.3,
                  overflow: !1,
                  transition: "cubic-bezier(0,0,0,1)",
                  customContainer: "",
                  customWrapper: "",
                  maxTransition: 0,
                }),
                (this.settings = Object.assign(this.defaults, n)),
                this.settings.customContainer)
              ) {
                var r = p(o(this.settings.customContainer), 1);
                this.customContainer = r[0];
              }
              (this.lastPosition = -1),
                (this.resizeIsDone = this.resizeIsDone.bind(this)),
                (this.refresh = this.refresh.bind(this)),
                (this.proceedRequestAnimationFrame =
                  this.proceedRequestAnimationFrame.bind(this)),
                this.init();
            }
          }
          var e, n, r;
          return (
            (e = t),
            (n = [
              {
                key: "init",
                value: function () {
                  var t = this;
                  s.setViewportAll(this.customContainer),
                    (T = [].concat(
                      m(
                        this.elements.map(function (e) {
                          return new f(e, t.settings);
                        }),
                      ),
                      m(T),
                    )),
                    w ||
                      (this.proceedRequestAnimationFrame(),
                      window.addEventListener("resize", this.resizeIsDone),
                      (w = !0));
                },
              },
              {
                key: "resizeIsDone",
                value: function () {
                  clearTimeout(b), (b = setTimeout(this.refresh, 200));
                },
              },
              {
                key: "proceedRequestAnimationFrame",
                value: function () {
                  var t = this;
                  s.setViewportTop(this.customContainer),
                    this.lastPosition !== s.positions.top
                      ? (s.setViewportBottom(),
                        T.forEach(function (e) {
                          t.proceedElement(e);
                        }),
                        (g = window.requestAnimationFrame(
                          this.proceedRequestAnimationFrame,
                        )),
                        (this.lastPosition = s.positions.top))
                      : (g = window.requestAnimationFrame(
                          this.proceedRequestAnimationFrame,
                        ));
                },
              },
              {
                key: "proceedElement",
                value: function (t) {
                  (this.customContainer ? t.checkIfVisible() : t.isVisible) &&
                    t.getTranslateValue() &&
                    t.animate();
                },
              },
              {
                key: "refresh",
                value: function () {
                  s.setViewportAll(this.customContainer),
                    T.forEach(function (t) {
                      t.getElementOffset(), t.getRangeMax();
                    }),
                    (this.lastPosition = -1);
                },
              },
              {
                key: "destroy",
                value: function () {
                  var t = this,
                    e = [];
                  (T = T.filter(function (n) {
                    return t.elements.includes(n.element) ? (e.push(n), !1) : n;
                  })),
                    e.forEach(function (e) {
                      e.unSetStyle(),
                        !1 === t.settings.overflow && e.unWrapElement();
                    }),
                    T.length ||
                      (window.cancelAnimationFrame(g),
                      window.removeEventListener("resize", this.refresh),
                      (w = !1));
                },
              },
            ]) && v(e.prototype, n),
            r && v(e, r),
            t
          );
        })();
    },
  ]).default;
});

/* SVG Loader */
(() => {
  "use strict";
  var t = {
      701: (t) => {
        let e = 0;
        t.exports = { incr: () => ++e, decr: () => --e, curr: () => e };
      },
      941: (t) => {
        t.exports = (t, e, r = "") => {
          const n = /url\(['"]?#([\w:.-]+)['"]?\)/g,
            a = /#([\w:.-]+)/g;
          return (
            e.match(n) &&
              (e = e.replace(n, function (e, r) {
                return t[r] ? `url(#${t[r]})` : e;
              })),
            ["href", "xlink:href"].includes(r) &&
              e.match(a) &&
              (e = e.replace(a, function (e, r) {
                return t[r] ? `#${t[r]}` : e;
              })),
            e
          );
        };
      },
      905: (t) => {
        t.exports = (t, e, r) => {
          const n = new RegExp("([^\r\n,{}]+)(,(?=[^}]*{)|s*{)", "g");
          return t.replace(n, function (t, n, a) {
            if (
              n.match(
                /^\s*(@media|@.*keyframes|to|from|@font-face|1?[0-9]?[0-9])/,
              )
            )
              return n + a;
            const o = n.match(/#(\w+)/);
            return (
              o && r[o[1]] && (n = n.replace(o[0], `#${r[o[1]]}`)),
              (n = n.replace(/^(\s*)/, "$1" + e + " ")) + a
            );
          });
        };
      },
      678: (t, e, r) => {
        function n(t) {
          return new Promise((e, r) => {
            (t.oncomplete = t.onsuccess = () => e(t.result)),
              (t.onabort = t.onerror = () => r(t.error));
          });
        }
        function a(t, e) {
          const r = indexedDB.open(t);
          r.onupgradeneeded = () => r.result.createObjectStore(e);
          const a = n(r);
          return (t, r) => a.then((n) => r(n.transaction(e, t).objectStore(e)));
        }
        let o;
        function s() {
          return o || (o = a("keyval-store", "keyval")), o;
        }
        function i(t, e = s()) {
          return e("readonly", (e) => n(e.get(t)));
        }
        function c(t, e, r = s()) {
          return r("readwrite", (r) => (r.put(e, t), n(r.transaction)));
        }
        function u(t, e = s()) {
          return e(
            "readwrite",
            (e) => (t.forEach((t) => e.put(t[1], t[0])), n(e.transaction)),
          );
        }
        function l(t, e = s()) {
          return e("readonly", (e) => Promise.all(t.map((t) => n(e.get(t)))));
        }
        function d(t, e, r = s()) {
          return r(
            "readwrite",
            (r) =>
              new Promise((a, o) => {
                r.get(t).onsuccess = function () {
                  try {
                    r.put(e(this.result), t), a(n(r.transaction));
                  } catch (t) {
                    o(t);
                  }
                };
              }),
          );
        }
        function f(t, e = s()) {
          return e("readwrite", (e) => (e.delete(t), n(e.transaction)));
        }
        function h(t, e = s()) {
          return e(
            "readwrite",
            (e) => (t.forEach((t) => e.delete(t)), n(e.transaction)),
          );
        }
        function b(t = s()) {
          return t("readwrite", (t) => (t.clear(), n(t.transaction)));
        }
        function g(t, e) {
          return (
            (t.openCursor().onsuccess = function () {
              this.result && (e(this.result), this.result.continue());
            }),
            n(t.transaction)
          );
        }
        function y(t = s()) {
          return t("readonly", (t) => {
            if (t.getAllKeys) return n(t.getAllKeys());
            const e = [];
            return g(t, (t) => e.push(t.key)).then(() => e);
          });
        }
        function p(t = s()) {
          return t("readonly", (t) => {
            if (t.getAll) return n(t.getAll());
            const e = [];
            return g(t, (t) => e.push(t.value)).then(() => e);
          });
        }
        function m(t = s()) {
          return t("readonly", (e) => {
            if (e.getAll && e.getAllKeys)
              return Promise.all([n(e.getAllKeys()), n(e.getAll())]).then(
                ([t, e]) => t.map((t, r) => [t, e[r]]),
              );
            const r = [];
            return t("readonly", (t) =>
              g(t, (t) => r.push([t.key, t.value])).then(() => r),
            );
          });
        }
        r.r(e),
          r.d(e, {
            clear: () => b,
            createStore: () => a,
            del: () => f,
            delMany: () => h,
            entries: () => m,
            get: () => i,
            getMany: () => l,
            keys: () => y,
            promisifyRequest: () => n,
            set: () => c,
            setMany: () => u,
            update: () => d,
            values: () => p,
          });
      },
    },
    e = {};
  function r(n) {
    var a = e[n];
    if (void 0 !== a) return a.exports;
    var o = (e[n] = { exports: {} });
    return t[n](o, o.exports, r), o.exports;
  }
  (r.d = (t, e) => {
    for (var n in e)
      r.o(e, n) &&
        !r.o(t, n) &&
        Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
  }),
    (r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
    (r.r = (t) => {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(t, "__esModule", { value: !0 });
    }),
    (() => {
      const { get: t, set: e, del: n, entries: a } = r(678),
        o = r(905),
        s = r(941),
        i = r(701),
        c = [],
        u = {},
        l = (t, e, r) => {
          const { enableJs: n, disableUniqueIds: a, disableCssScoping: l } = e,
            d = new DOMParser().parseFromString(r, "text/html"),
            f = d.querySelector("svg"),
            h = (() => {
              if (c.length) return c;
              for (const t in document.head) t.startsWith("on") && c.push(t);
              return c;
            })(),
            b = u[t.getAttribute("data-id")] || new Set(),
            g = t.getAttribute("data-id") || `svg-loader_${i.incr()}`,
            y = {};
          a ||
            Array.from(d.querySelectorAll("[id]")).forEach((t) => {
              const e = t.getAttribute("id"),
                r = `${e}_${i.incr()}`;
              t.setAttribute("id", r), (y[e] = r);
            }),
            Array.from(d.querySelectorAll("*")).forEach((e) => {
              if ("script" === e.tagName) {
                if ((e.remove(), !n)) return;
                {
                  const r = document.createElement("script");
                  r.appendChild(e.childNodes[0]), t.appendChild(r);
                }
              }
              const r = [];
              for (let t = 0; t < e.attributes.length; t++) {
                const { name: a, value: o } = e.attributes[t],
                  i = s(y, o, a);
                o !== i && e.setAttribute(a, i),
                  !h.includes(a.toLowerCase()) || n
                    ? ["href", "xlink:href"].includes(a) &&
                      o.startsWith("javascript") &&
                      !n &&
                      r.push(a)
                    : r.push(a);
              }
              if (
                (r.forEach((t) => e.removeAttribute(t)),
                "style" === e.tagName && !l)
              ) {
                let t = o(e.innerHTML, `[data-id="${g}"]`, y);
                (t = s(y, t)), t !== e.innerHTML && (e.innerHTML = t);
              }
            });
          for (let e = 0; e < f.attributes.length; e++) {
            const { name: r, value: n } = f.attributes[e];
            (t.getAttribute(r) && !b.has(r)) ||
              (b.add(r), t.setAttribute(r, n));
          }
          (u[g] = b), t.setAttribute("data-id", g), (t.innerHTML = f.innerHTML);
          const p = new CustomEvent("iconload", { bubbles: !0 });
          if ((t.dispatchEvent(p), t.getAttribute("oniconload"))) {
            t.setAttribute("onauxclick", t.getAttribute("oniconload"));
            const e = new CustomEvent("auxclick", {
              bubbles: !1,
              view: window,
            });
            t.dispatchEvent(e), t.removeAttribute("onauxclick");
          }
        },
        d = {},
        f = {},
        h = async (r) => {
          const a = r.getAttribute("data-src"),
            o = r.getAttribute("data-cache"),
            s = "enabled" === r.getAttribute("data-js"),
            i = "disabled" === r.getAttribute("data-unique-ids"),
            c = "disabled" === r.getAttribute("data-css-scoping"),
            u = await (async (e) => {
              let r;
              try {
                r = await t(`loader_${e}`);
              } catch (t) {}
              if (!r)
                try {
                  r = localStorage.getItem(`loader_${e}`);
                } catch (t) {}
              if (r)
                return (
                  (r = JSON.parse(r)),
                  Date.now() < r.expiry ? r.data : void n(`loader_${e}`)
                );
            })(a),
            b = "disabled" !== o,
            g = l.bind(self, r, {
              enableJs: s,
              disableUniqueIds: i,
              disableCssScoping: c,
            });
          if (f[a] || (b && u)) {
            const t = f[a] || u;
            g(t);
          } else {
            if (d[a]) return void setTimeout(() => h(r), 20);
            (d[a] = !0),
              fetch(a)
                .then((t) => {
                  if (!t.ok)
                    throw Error(
                      `Request for '${a}' returned ${t.status} (${t.statusText})`,
                    );
                  return t.text();
                })
                .then((t) => {
                  const r = t.toLowerCase().trim();
                  if (!r.startsWith("<svg") && !r.startsWith("<?xml"))
                    throw Error(`Resource '${a}' returned an invalid SVG file`);
                  b &&
                    (async (t, r, n) => {
                      const a = parseInt(n, 10),
                        o = JSON.stringify({
                          data: r,
                          expiry: Date.now() + (Number.isNaN(a) ? 2592e6 : a),
                        });
                      try {
                        await e(`loader_${t}`, o);
                      } catch (e) {
                        try {
                          localStorage.setItem(`loader_${t}`, o);
                        } catch (t) {
                          console.warn("Failed to set cache: ", t);
                        }
                      }
                    })(a, t, o),
                    (f[a] = t),
                    g(t);
                })
                .catch((t) => {
                  console.error(t);
                })
                .finally(() => {
                  delete d[a];
                });
          }
        };
      let b;
      globalThis.IntersectionObserver &&
        (b = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              t.isIntersecting && (h(t.target), b.unobserve(t.target));
            });
          },
          { rootMargin: "1200px" },
        ));
      const g = [];
      function y() {
        Array.from(
          document.querySelectorAll("svg[data-src]:not([data-id])"),
        ).forEach((t) => {
          -1 === g.indexOf(t) &&
            (g.push(t),
            "lazy" === t.getAttribute("data-loading") ? b.observe(t) : h(t));
        });
      }
      let p = !1;
      if (globalThis.addEventListener) {
        const m = setInterval(() => {
          y();
        }, 100);
        function v() {
          clearInterval(m),
            y(),
            p ||
              ((p = !0),
              new MutationObserver((t) => {
                t.some((t) =>
                  Array.from(t.addedNodes).some(
                    (t) =>
                      t.nodeType === Node.ELEMENT_NODE &&
                      ((t.getAttribute("data-src") &&
                        !t.getAttribute("data-id")) ||
                        t.querySelector("svg[data-src]:not([data-id])")),
                  ),
                ) && y(),
                  t.forEach((t) => {
                    "attributes" === t.type && h(t.target);
                  });
              }).observe(document.documentElement, {
                attributeFilter: ["data-src"],
                attributes: !0,
                childList: !0,
                subtree: !0,
              }));
        }
        "interactive" === document.readyState
          ? v()
          : globalThis.addEventListener("DOMContentLoaded", () => {
              v();
            });
      }
      (globalThis.SVGLoader = {}),
        (globalThis.SVGLoader.destroyCache = async () => {
          try {
            const t = await a();
            for (const e of t) e[0].startsWith("loader_") && (await n(e[0]));
          } catch (t) {}
          Object.keys(localStorage).forEach((t) => {
            t.startsWith("loader_") && localStorage.removeItem(t);
          });
        });
    })();
})();
window.addEventListener("iconload", (e) => {
  if (e.target.getAttribute("viewBox") == null) {
    e.target.setAttribute(
      "viewBox",
      `0 0 ${e.target.getAttribute("width")} ${e.target.getAttribute("height")}`,
    );
  }
});
